import { FC } from 'react'
import { SectionValueAndStyleProps } from '@magal/models'
import { styled } from '@magal/styles'
import { Container, Link, SectionWrap, BlockContent } from '@magal/components'

const Root = styled(Container, {
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: '$48 $6',
  '@lg': {
    gridTemplateColumns: 'repeat(4, 1fr)',
  },
  color: '$green_09',
})

const Sidebar = styled('div', {
  display: 'grid',
  gap: '$32',
  placeContent: 'start',
})

const Title = styled('h2', {
  projectFont: 'caps04',
  textDecoration: 'underline',
  textUnderlineOffset: '3px',
})

const Panels = styled('div', {
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: '$6',
  '@lg': {
    gridColumn: 'span 3',
    gridTemplateColumns: 'repeat(3, 1fr)',
  },
})

const Panel = styled('div', {
  minHeight: '0',
  backgroundColor: '$gray300',
  padding: '$28 $28 $64 $28',
})

const PanelTitle = styled('h3', {
  projectFont: 'caps02',
})

const PanelDescription = styled('div', {
  marginTop: '$20',
})

// TODO: tablet sizes

export const SectionValueAndStyle: FC<SectionValueAndStyleProps> = ({
  title,
  panels,
  button,
}) => {
  return (
    <SectionWrap>
      <Root>
        <Sidebar>
          <Title>{title}</Title>
          <Link {...button?.link} appearance="outlineGreen">
            {button?.label}
          </Link>
        </Sidebar>
        {panels && panels.length > 0 && (
          <Panels>
            {panels.map(({ title, description }, index) => (
              <Panel key={`${index}`}>
                <PanelTitle>{title}</PanelTitle>
                <PanelDescription>
                  <BlockContent body={description} />
                </PanelDescription>
              </Panel>
            ))}
          </Panels>
        )}
      </Root>
    </SectionWrap>
  )
}
